(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[92559,52892],{

/***/ 5678:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-with-us",
      function () {
        return __webpack_require__(41651);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./src/components/layouts/globalPagesWrapper.tsx
var globalPagesWrapper = __webpack_require__(45594);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/partnerWithUs/style.module.scss
var style_module = __webpack_require__(4568);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/shared/contactUs/contactUsForm.tsx + 3 modules
var contactUsForm = __webpack_require__(31750);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/shared/partnerWithUs/partner-with-us.png
/* harmony default export */ var partner_with_us = ({"src":"/_next/static/media/partner-with-us.072b3b08.png","height":964,"width":789,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAVFBMVEVMaXFVVURAPEAcHCU5OERtSkA+JyAUDhAHBwuIdGE/Ojs5MSs2MjwcGyKzl3r///87MziuhHYNDRIsJix6eH9AQE4tLTpKNCzHk4AuKzUiIilYSkrdb69JAAAAF3RSTlMAB2nG/Y1x/v4lGlD96FEL99eq4PyvnUrGJ0UAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA9SURBVHicFcRXFkARDAXAi5BE93rZ/z4d8zGAgX8aFj/W0dFxRqjtmchC0/7m/4LWTbgkhJvlc0BgES5mAjl9AgGC+D9+AAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/shared/partnerWithUs/generic.png
/* harmony default export */ var generic = ({"src":"/_next/static/media/generic.35cf9b9c.png","height":616,"width":404,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAS1BMVEVUU1qggG6ioqKbm51CQEV6W0xFQUZMaXFxcXTfw7hdUFCGhImrq65ERUuLhIppY2ZDQUdISExjb4Xh4eS7vL01NTx2YV5oa3XToItqcp6dAAAAFXRSTlP+z9r7/ilMAORYaNdixf24+rT8YPuyzwzvAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMklEQVR4nAXBBwKAIAwAsWMWUKYW+f9LTZBggiD5ZOF27X24WJ8leTTR96ASt2cSVbX8JVEBtxfNX10AAAAASUVORK5CYII=","blurWidth":5,"blurHeight":8});
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/components/shared/partnerWithUs/genericPartnerWithUsForm.ts
var genericPartnerWithUsForm = __webpack_require__(30888);
;// CONCATENATED MODULE: ./src/components/shared/partnerWithUs/index.tsx










const PartnerWithUs = ()=>{
    const { domain , doNotSellFormStates , domainNameTranslation  } = (0,useDomainContext/* useDomainContext */.w)();
    const mvaFields = [
        {
            name: "describeYourOrganization",
            label: domain?.translations?.[`${domainNameTranslation}_partnerWithUsDescribeYourOrganizationLabel`] ?? "How Would You Describe Your Organization?",
            placeholder: domain?.translations?.[`${domainNameTranslation}_partnerWithUsPlaceholderSelectWord`] ?? "Select",
            inputType: "select",
            validation: {
                required: true,
                rules: {
                    type: "isEmpty"
                }
            },
            options: [
                {
                    label: domain?.translations?.[`${domainNameTranslation}_partnerWithUsOptionLawFirmLabel`] ?? "Law Firm",
                    value: "Law Firm",
                    id: 2
                },
                {
                    label: domain?.translations?.[`${domainNameTranslation}_partnerWithUsOptionMarketingAgencyLabel`] ?? "Marketing Agency",
                    value: "Marketing Agency",
                    id: 1
                }, 
            ],
            type: null,
            isExtraField: true
        },
        {
            name: "targetingStates",
            label: domain?.translations?.[`${domainNameTranslation}_partnerWithUsTargetingStatesLabel`] ?? "Which State(s) Are You Targeting?",
            placeholder: domain?.translations?.[`${domainNameTranslation}_partnerWithUsPlaceholderSelectWord`] ?? "Select",
            inputType: "multiSelect",
            validation: {
                required: true,
                rules: {
                    type: "isEmpty"
                }
            },
            options: doNotSellFormStates?.map((i)=>({
                    label: i.label,
                    value: i.label,
                    id: i.id
                })) ?? [],
            type: null,
            isExtraField: true
        },
        {
            name: "casesHandlePerMonth",
            label: domain?.translations?.[`${domainNameTranslation}_partnerWithUsCasesHandlePerMonthLabel`] ?? "How Many Cases Are You Willing to Handle Per Month?",
            placeholder: domain?.translations?.[`${domainNameTranslation}_partnerWithUsPlaceholderSelectWord`] ?? "Select",
            inputType: "select",
            validation: {
                required: true,
                rules: {
                    type: "isEmpty"
                }
            },
            options: [
                {
                    label: domain?.translations?.[`${domainNameTranslation}_partnerWithUsLessThan5Label`] ?? "Less than 5",
                    value: "Less Than 5",
                    id: 1
                },
                {
                    label: domain?.translations?.[`${domainNameTranslation}_partnerWithUs5To10Label`] ?? "5 To 10",
                    value: "5 To 10",
                    id: 2
                },
                {
                    label: "10+",
                    value: "10+",
                    id: 3
                }, 
            ],
            type: null,
            isExtraField: true
        },
        {
            name: "companyName",
            label: domain?.translations?.[`${domainNameTranslation}_partnerWithUsCompanyNameLabel`] ?? "Company Name",
            placeholder: domain?.translations?.[`${domainNameTranslation}_partnerWithUsCompanyNamePlaceholder`] ?? "Company Name",
            inputType: "text",
            type: "text",
            validation: {
                required: true,
                rules: {
                    type: "isEmpty"
                }
            },
            isExtraField: true
        },
        {
            name: "firstName",
            label: domain?.translations?.[`${domainNameTranslation}_partnerWithUsFirstNameLabel`] ?? "First Name",
            placeholder: domain?.translations?.[`${domainNameTranslation}_partnerWithUsFirstNamePlaceholder`] ?? "First Name",
            inputType: "text",
            type: "text",
            validation: {
                required: true,
                rules: {
                    type: "isEmpty"
                }
            },
            autocomplete: "given-name",
            serverSideValidation: true
        },
        {
            name: "lastName",
            label: domain?.translations?.[`${domainNameTranslation}_partnerWithUsLastNameLabel`] ?? "Last Name",
            placeholder: domain?.translations?.[`${domainNameTranslation}_partnerWithUsLastNamePlaceholder`] ?? "Last Name",
            inputType: "text",
            type: "text",
            validation: {
                required: true,
                rules: {
                    type: "isEmpty"
                }
            },
            autocomplete: "family-name",
            serverSideValidation: true
        },
        {
            name: "email",
            label: domain?.translations?.[`${domainNameTranslation}_partnerWithUsEmailLabel`] ?? "Email",
            placeholder: domain?.translations?.[`${domainNameTranslation}_partnerWithUsEmailPlaceholder`] ?? "Email",
            inputType: "text",
            type: "email",
            validation: {
                required: true,
                rules: {
                    type: "isEmail"
                }
            },
            autocomplete: "email",
            serverSideValidation: true
        },
        {
            name: "phone",
            label: domain?.translations?.[`${domainNameTranslation}_partnerWithUsPhoneLabel`] ?? "Phone Number",
            placeholder: domain?.translations?.[`${domainNameTranslation}_partnerWithUsPhonePlaceholder`] ?? "Phone Number",
            inputType: "text",
            type: "tel",
            validation: {
                required: true,
                rules: {
                    type: "isPhone"
                }
            },
            autocomplete: "tel"
        },
        {
            name: "googleReCaptcha",
            label: "",
            placeholder: "",
            inputType: "recaptcha",
            type: null,
            validation: {
                required: true
            }
        }, 
    ];
    const isMVA = domain.categories.every((c)=>sharedUtils/* commonPartnerWithUsAllowedCategories.includes */.v.includes(c.slug));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:flex-row lg:gap-32 mb-20 w-full items-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[600px] mx-auto lg:mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "font-bold lg:text-5xl text-3xl lg:leading-[3.5rem] leading-8",
                        children: domain?.translations?.[`${domainNameTranslation}_partnerWithUsTitle`] ?? "Partner With Us"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: " lg:text-lg lg:leading-8 font-light mt-3 mb-3",
                        children: domain?.translations?.[`${domainNameTranslation}_partnerWithUsDescription`] ?? "Partner with our expert team to generate high-quality leads and increase your sales revenue. Contact us today."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `${(style_module_default()).form}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contactUsForm/* default */.Z, {
                            primaryColor: "var(--primary, #bf0a2f)",
                            secondaryColor: "#000000",
                            submitButtonTitle: domain?.translations?.[`${domainNameTranslation}_partnerWithUsSendButton`] ?? "Send",
                            classes: {
                                formClassName: (style_module_default()).form,
                                fieldWrapperClassName: isMVA ? (style_module_default())["mva-field-wrapper"] : (style_module_default())["generic-field-wrapper"],
                                fieldClassName: (style_module_default()).field,
                                selectFieldClassName: (style_module_default()).field,
                                fieldErrorClassName: (style_module_default()).errorStyle,
                                thankYouStepClassName: (style_module_default()).thankYouStyle
                            },
                            domainInfo: domain,
                            fields: isMVA ? mvaFields : genericPartnerWithUsForm/* genericFields */.A,
                            type: "partnerWithUs",
                            category: domain.categories[0].name,
                            message: domain?.translations?.[`${domainNameTranslation}_partnerWithUsMessage`] ?? "Please enter the details of your request, a member of our support staff will get back to you within 24 hours"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `mx-auto lg:mx-0  md:w-[460px] md:min-w-[460px] md:h-[600px]  sticky top-0 `,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: isMVA ? partner_with_us : generic,
                    alt: "img",
                    layout: "fill",
                    objectFit: "contain",
                    priority: true
                })
            })
        ]
    });
};
/* harmony default export */ var partnerWithUs = (PartnerWithUs);

;// CONCATENATED MODULE: ./pages/partner-with-us/index.tsx




var __N_SSP = true;
function Index() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(globalPagesWrapper/* default */.Z, {
        children: [
            (0,jsx_runtime.jsx)((style_default()), {
                id: "7fdf6490e086a2e8",
                children: "body{overflow-x:unset}"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(partnerWithUs, {})
        ]
    });
}


/***/ }),

/***/ 30888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ genericFields; }
/* harmony export */ });
const genericFields = [
    {
        name: "firstName",
        label: "First Name",
        placeholder: "First Name",
        inputType: "text",
        type: "text",
        validation: {
            required: true,
            rules: {
                type: "isEmpty"
            }
        },
        autocomplete: "given-name",
        serverSideValidation: true
    },
    {
        name: "lastName",
        label: "Last Name",
        placeholder: "Last Name",
        inputType: "text",
        type: "text",
        validation: {
            required: true,
            rules: {
                type: "isEmpty"
            }
        },
        autocomplete: "family-name",
        serverSideValidation: true
    },
    {
        name: "companyName",
        label: "Company Name",
        placeholder: "Company Name",
        inputType: "text",
        type: "text",
        validation: {
            required: true,
            rules: {
                type: "isEmpty"
            }
        },
        isExtraField: true
    },
    {
        name: "email",
        label: "Email",
        placeholder: "Email",
        inputType: "text",
        type: "email",
        validation: {
            required: true,
            rules: {
                type: "isEmail"
            }
        },
        autocomplete: "email",
        serverSideValidation: true
    },
    {
        name: "phone",
        label: "Phone Number",
        placeholder: "Phone Number",
        inputType: "text",
        type: "tel",
        validation: {
            required: true,
            rules: {
                type: "isPhone"
            }
        },
        autocomplete: "tel"
    },
    {
        name: "subject",
        label: "Subject",
        placeholder: "Subject",
        inputType: "text",
        type: "text",
        validation: {
            required: true,
            rules: {
                type: "isEmpty",
                characterCount: {
                    min: 3,
                    max: 255
                }
            }
        }
    },
    {
        name: "body",
        label: "Description",
        placeholder: "Please enter the details of your request. A member of our support staff will get back to you within 24 hours",
        inputType: "textarea",
        type: null,
        rows: 5,
        validation: {
            required: true,
            rules: {
                type: "isEmpty",
                characterCount: {
                    min: 5,
                    max: 255
                }
            }
        }
    },
    {
        name: "googleReCaptcha",
        label: "",
        placeholder: "",
        inputType: "recaptcha",
        type: null,
        validation: {
            required: true
        }
    }, 
];


/***/ }),

/***/ 4568:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__SG4kv","errorStyle":"style_errorStyle__QOdwG","thankYouStyle":"style_thankYouStyle__pfY4f","mva-field-wrapper":"style_mva-field-wrapper__MakDv","field":"style_field__3BM2L","generic-field-wrapper":"style_generic-field-wrapper__5BBuL"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5118,3168,198,31750,66699,45594,49774,92888,40179], function() { return __webpack_exec__(5678); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);